import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi) // Carrega traduções de /public/locales (ou do caminho em `loadPath`)
  .use(LanguageDetector) // Detecta o idioma do usuário
  .use(initReactI18next) // Passa i18n para react-i18next
  .init({
    debug: true, // <<<< ADICIONADO PARA DEBUG
    supportedLngs: ['pt', 'en', 'es'],
    fallbackLng: 'pt', // Idioma padrão se a detecção falhar ou o idioma não for suportado
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'quiron_language', // Chave para salvar no localStorage
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Caminho para os arquivos de tradução (ns = namespace, padrão é 'translation')
    },
    react: {
      useSuspense: true, // Pode ser true se preferir lidar com Suspense para carregamento de traduções
    },
    // saveMissing: true, // Envia chaves faltantes para o backend (se configurado)
    // ns: ['translation'], // Define o namespace padrão explicitamente, se necessário
    // defaultNS: 'translation', // Define o namespace padrão explicitamente
  });

export default i18n;
